var EventEmitter = {};

export { EventEmitter as __exports };
//# sourceMappingURL=EventEmitter.js.map
